import { BreakpointFn } from './is-mobile.types';

// Seguindo o mesmo padrão do SAVA Estudantes/Educadores que considera mobile, tudo abaixo de 1024px (pixels de css)
export const isMobile: BreakpointFn = () => window.innerWidth < 1024;
export const isTablet: BreakpointFn = () => window.innerWidth >= 768 && window.innerWidth < 1024;
